/* iceberg-ui */
import { Box, FadeScroll, Flex, Text } from '@auviknetworks/iceberg-ui';

/* MUI */
import { useTheme } from '@mui/material/styles';

/* Images */
import { AuvikANMLogo } from 'application/Shared/Components/App/AuvikLogo';

/* Shared */
import { Route } from 'application/Shared/Helpers';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

const headerHeight = '80px';
const backButtonHeight = '64px';

export const ANMTrialContainer = ({ leftPanel, rightPanel }) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { partnerId } = useParams();
    const route = Route.buildBasePartnerRoute({ partnerId });
    return (
        <Flex
            flexDirection={['column', 'column', 'row']}
            left={0}
            height="100vh"
            minWidth="818px"
            position="fixed"
            top={0}
            width="100%"
            overflow={['auto', 'auto', 'visible']}
            data-testid="anmTrialContainer"
        >
            <Flex
                width={['100%', '100%', '50%']}
                bg={theme.palette.anmTrial.backgroundColorPrimary}
                flexDirection="column"
            >
                <Flex
                    height={backButtonHeight}
                    ml={4}
                    mt="8px"
                    alignItems="center"
                >
                    <Link
                        to={`${route}/dashboard`}
                        data-trackid="partner_anmTrail_backtoASMB_routeTo"
                    >
                        <Text
                            color={theme.palette.anmTrial.linkColor}
                            data-testid="backtoASMBtn"
                            data-trackid="backtoASMBtn"
                            href="partner/dashboard"
                        >
                            {t('anmTrial.back')}
                        </Text>
                    </Link>
                </Flex>
                <Box m={4} textAlign="center" height={headerHeight}>
                    <AuvikANMLogo style={{ width: '180px' }} />
                </Box>
                <FadeScroll
                    fadePx={5}
                    height={[
                        'auto',
                        'auto',
                        `calc(100vh - ${headerHeight} - ${backButtonHeight})`
                    ]}
                >
                    {leftPanel}
                </FadeScroll>
            </Flex>
            <Flex
                flexDirection="column"
                justifyContent="center"
                width={['100%', '100%', '50%']}
                minHeight={['650px', '650px', 0]}
                bg={theme.palette.anmTrial.backgroundColorSecondary}
            >
                {rightPanel}
            </Flex>
        </Flex>
    );
};
